import { motion } from 'framer-motion';

const feeCards = [
  {
    category: 'Scene',
    desc: 'A single scene, any length. The lowest barrier to entry in any major festival.',
    tiers: [
      { label: 'Early Bird — by Sep 18', price: '$15' },
      { label: 'Regular — by Oct 23', price: '$20' },
      { label: 'Late — by Nov 20', price: '$25' },
    ],
    addon: null,
  },
  {
    category: 'Short / Vertical',
    desc: 'Films under 40 minutes. Vertical format films shot for mobile screens.',
    tiers: [
      { label: 'Early Bird — by Sep 18', price: '$20' },
      { label: 'Regular — by Oct 23', price: '$25' },
      { label: 'Late — by Nov 20', price: '$30' },
    ],
    addon: '+ $10 to also submit a scene',
  },
  {
    category: 'Feature / Doc',
    desc: 'Features and documentaries 40 minutes and over. All genres welcome.',
    tiers: [
      { label: 'Early Bird — by Sep 18', price: '$25' },
      { label: 'Regular — by Oct 23', price: '$30' },
      { label: 'Late — by Nov 20', price: '$35' },
    ],
    addon: '+ $10 to also submit a scene',
  },
];

export default function SubmissionFees() {
  return (
    <section className="bg-dark py-24">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Eyebrow */}
        <motion.span
          className="font-mono text-teal uppercase block mb-4"
          style={{ fontSize: '0.7rem', letterSpacing: '0.25em' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Submission Fees
        </motion.span>

        {/* Title */}
        <motion.h2
          className="font-display text-white leading-none mb-12"
          style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Low barriers. High ambition.
        </motion.h2>

        {/* Fee Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {feeCards.map((card, i) => (
            <motion.div
              key={card.category}
              className="bg-dark2 rounded-lg p-8"
              style={{ border: '1px solid rgba(255,255,255,0.06)' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
            >
              {/* Category */}
              <h3
                className="font-display text-teal mb-3"
                style={{ fontSize: '1.5rem' }}
              >
                {card.category}
              </h3>

              {/* Description */}
              <p
                className="text-light/60 leading-relaxed mb-6"
                style={{ fontSize: '0.85rem' }}
              >
                {card.desc}
              </p>

              {/* Tier Rows */}
              <div className="space-y-3">
                {card.tiers.map((tier) => (
                  <div
                    key={tier.label}
                    className="flex items-center justify-between"
                  >
                    <span
                      style={{ fontSize: '0.78rem', color: 'rgba(245,245,240,0.5)' }}
                    >
                      {tier.label}
                    </span>
                    <span className="font-mono text-white text-sm">
                      {tier.price}
                    </span>
                  </div>
                ))}
              </div>

              {/* Add-on Chip */}
              {card.addon && (
                <div
                  className="mt-6 text-center rounded-md py-2 px-4 text-teal font-medium"
                  style={{
                    fontSize: '0.78rem',
                    backgroundColor: 'rgba(42,191,163,0.08)',
                    border: '1px solid rgba(42,191,163,0.3)',
                  }}
                >
                  {card.addon}
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* Fee Note */}
        <motion.p
          className="mt-10 text-center italic"
          style={{ fontSize: '0.8rem', color: 'rgba(245,245,240,0.4)' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Fee waivers available for filmmakers from lower-income countries and
          first-time filmmakers. Email{' '}
          <a
            href="mailto:synemafest@gmail.com"
            className="text-teal font-bold not-italic"
          >
            synemafest@gmail.com
          </a>
        </motion.p>
      </div>
    </section>
  );
}
